export { default as totalAssets } from './totalAssets';
export { default as transferredAssets } from './transferredAssets';
export { default as homeOwnership } from './homeOwnership';
export { default as landLotSize } from './landLotSize';
export { default as marketableLand } from './marketableLand';
export { default as incomeSources } from './incomeSources';
